$(window).on("load",function(){
	$("body").removeClass("preload");
});
$(function(){

	var body = $('body');

	//SVGスプライト
	$.ajax({
		type: 'get',
		url: '/wp/wp-content/themes/well/assets/svg/icons.svg'//ここにパスを入れる（環境に合わせて変更）
	}).done(function(data) {
		var svg = $(data).find('svg');
		body.prepend(svg);
	});

	//ページ内スクロール
	$.smooziee();

	//スクロールしたらクラスを付与
	$(window).scroll(function () {
		if ($(this).scrollTop() > 160) {
			body.addClass("scroll");
		} else {
			body.removeClass("scroll");
		}
	});

	// スクロールアニメーション
	$('.animate').scrolla({
		mobile: true, // モバイルの有効・無効
		once: true, // 発火は１度だけか、視界に入るたびに発火させるか
		animateCssVersion: 4 // used animate.css version (3 or 4)
	});

	//グロナビ　アコーディオン
	$('.accordion_trigger').on('click', function () {
		if($(this).next(".accordion_content").hasClass('open')){
			$(this).removeClass('open');
			$(this).next(".accordion_content").removeClass('open');
		} else {
			$(this).addClass('open');
			$(".accordion_content").removeClass("open");
			$(this).next(".accordion_content").addClass('open');
		}
	});

	//スマホメニュー　アコーディオン
	$('.sp_submenu_trigger').on('click', function () {
		$(this).toggleClass('open');
		$(this).next(".sp_submenu_content").slideToggle();
	});

	//開閉用ボタンをクリックでクラスの切替え
	$('.sp_menu_trigger').on('click', function () {
		$('html').toggleClass('open');
		return false;
	});

	//メニュー閉じる
	$('.sp_menu_layer').on('click', function () {
		if($('html').hasClass('open')){
			$('html').removeClass('open');
			return false;
		}
	});

	//パララックス 上移動
	const elem = document.querySelector(".parallax_up");
	if (elem !== null) {
		let target = document.getElementsByClassName("parallax_up");
			let parallaxConfig = {
				delay: 0, // スクロール止めてから動く秒数
				orientation: "up", // 動く方向
				scale: 1.3, // 動く大きさ
				overflow: true,
			};
		const parallax_instance = new simpleParallax(target, parallaxConfig);
	}

	//パララックス 下移動
	const elem02 = document.querySelector(".parallax_down");
	if (elem02 !== null) {
		let target = document.getElementsByClassName("parallax_down");
			let parallaxConfig = {
				delay: 0, // スクロール止めてから動く秒数
				orientation: "down", // 動く方向
				scale: 1.3, // 動く大きさ
				overflow: true,
			};
		const parallax_instance = new simpleParallax(target, parallaxConfig);
	}

	//ループスライダー
	const swiper = new Swiper('.roop_slider', {
		loop: true,
		slidesPerView: 'auto',
		allowTouchMove: false, // スワイプ無効
		preventInteractionOnTransition: true, //クリックなどをしてもスライダーの停止を防ぐ
		speed: 8000,
		autoplay: {
			delay: 0,
		},
		spaceBetween:20,
		breakpoints: {
			// スライドの表示枚数：768px以上の場合
			768: {
				spaceBetween:30,
			}
		},
	});

	//ループスライダー
	$('.faq_list dt').on('click', function () {
		$(this).next('dd').slideToggle();
		$(this).toggleClass("open");
	});

	//タイマー
	$(".view_timer").each(function(index, target) {
		var startDate = $(this).attr("data-start-date");
		var endDate = $(this).attr("data-end-date");
		var nowDate = new Date();
		if (startDate) {
			startDate = new Date(startDate);
		} else {
			startDate = nowDate;
		}
		if (endDate) {
			endDate = new Date(endDate);
		}
		if (startDate <= nowDate && (!endDate || nowDate <= endDate)) {
			$(this).show();
		} else {
			$(this).hide();
		}
	});

	//トップページ｜改善症例詳細 のみ
	if($('.home').length || $('.single-improvement').length){
		//症例 スライド
		// window.addEventListener('DOMContentLoaded', () => {
		$(function(){
			const breakPoint = 768;
			// console.log("hoge");
		  	// cases_swiperのoption は使い回すので別に書く
		  	const cases_options = {
				loop: true, // ループさせる
				slidesPerView: 'auto',
				spaceBetween:15,
				autoplay: {
					// 自動再生
					delay: 3000, // 3秒後に次のスライド
					disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
				},
				// ページネーション
				pagination: {
					el: ".swiper-pagination",
					clickable: true, // クリック可能にする
				},
				// 前後の矢印
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
		  	}
		  	let cases_swiper;
		  	if ( window.innerWidth <= breakPoint ) {
		    	cases_swiper = new Swiper('.cases_swiper', cases_options);
		 	} else {
		    	cases_swiper = undefined;
		  	}
		  	// $(window).on('resize', function(){
		  	window.addEventListener('resize', () => {
		    	if ( window.innerWidth <= breakPoint ) {
		      		if( cases_swiper ) return;
		      		cases_swiper = new Swiper('.cases_swiper', cases_options);
			    } else {
			      	if( !cases_swiper ) return;
			      	cases_swiper.destroy();
			      	cases_swiper = undefined;
			    }
	  		}, false);
		}, false);
		//ブログ スライド
		// window.addEventListener('DOMContentLoaded', () => {
		$(function(){
			const breakPoint = 768;
		  	// blog_swiperのoption は使い回すので別に書く
		  	const blog_options = {
				loop: true, // ループさせる
				slidesPerView: 'auto',
				spaceBetween:15,
				autoplay: {
					// 自動再生
					delay: 3000, // 3秒後に次のスライド
					disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
				},
				// ページネーション
				pagination: {
					el: ".swiper-pagination",
					clickable: true, // クリック可能にする
				},
				// 前後の矢印
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
		  	}
		  	let blog_swiper;
		  	if ( window.innerWidth <= breakPoint ) {
		    	blog_swiper = new Swiper('.blog_swiper', blog_options);
		  	} else {
		    	blog_swiper = undefined;
		  	}
		  	// $(window).on('resize', function(){
		 	window.addEventListener('resize', () => {
			    if ( window.innerWidth <= breakPoint ) {
			      	if( blog_swiper ) return;
			      	blog_swiper = new Swiper('.blog_swiper', blog_options);
			    } else {
			      	if( !blog_swiper ) return;
			      	blog_swiper.destroy();
			      	blog_swiper = undefined;
			    }
		  	}, false);
		}, false);
	}

	//スタッフ紹介 のみ
	if($('.staff').length){
		//ブログ01 スライド
		$(function(){
			const breakPoint = 768;
		  	// blog_swiperのoption は使い回すので別に書く
		  	const blog_options = {
				loop: true, // ループさせる
				slidesPerView: 'auto',
				spaceBetween:15,
				autoplay: {
					// 自動再生
					delay: 3000, // 3秒後に次のスライド
					disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
				},
				// ページネーション
				pagination: {
					el: ".swiper-pagination",
					clickable: true, // クリック可能にする
				},
				// 前後の矢印
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
		  	}
		  	let blog_swiper01;
		  	if ( window.innerWidth <= breakPoint ) {
		    	blog_swiper01 = new Swiper('.blog_swiper01', blog_options);
		  	} else {
		    	blog_swiper01 = undefined;
		  	}
		  	// $(window).on('resize', function(){
		 	window.addEventListener('resize', () => {
			    if ( window.innerWidth <= breakPoint ) {
			      	if( blog_swiper01 ) return;
			      	blog_swiper01 = new Swiper('.blog_swiper01', blog_options);
			    } else {
			      	if( !blog_swiper01 ) return;
			      	blog_swiper01.destroy();
			      	blog_swiper01 = undefined;
			    }
		  	}, false);
		}, false);
		//ブログ02 スライド
		$(function(){
			const breakPoint = 768;
		  	// blog_swiperのoption は使い回すので別に書く
		  	const blog_options = {
				loop: true, // ループさせる
				slidesPerView: 'auto',
				spaceBetween:15,
				autoplay: {
					// 自動再生
					delay: 3000, // 3秒後に次のスライド
					disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
				},
				// ページネーション
				pagination: {
					el: ".swiper-pagination",
					clickable: true, // クリック可能にする
				},
				// 前後の矢印
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
		  	}
		  	let blog_swiper02;
		  	if ( window.innerWidth <= breakPoint ) {
		    	blog_swiper02 = new Swiper('.blog_swiper02', blog_options);
		  	} else {
		    	blog_swiper02 = undefined;
		  	}
		  	// $(window).on('resize', function(){
		 	window.addEventListener('resize', () => {
			    if ( window.innerWidth <= breakPoint ) {
			      	if( blog_swiper02 ) return;
			      	blog_swiper02 = new Swiper('.blog_swiper02', blog_options);
			    } else {
			      	if( !blog_swiper02 ) return;
			      	blog_swiper02.destroy();
			      	blog_swiper02 = undefined;
			    }
		  	}, false);
		}, false);
	}

	//Wellの施術 のみ
	if($('.treatment').length){
		//約束 スライド01
		$(function(){
			const breakPoint = 768;
		  	// blog_swiperのoption は使い回すので別に書く
		  	const blog_options = {
				slidesPerView: 'auto',
				spaceBetween:15,
				pagination: {
					el: ".swiper-pagination",
					clickable: true, // クリック可能にする
				},
				// 前後の矢印
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
		  	}
		  	let promise_swiper01;
		  	if ( window.innerWidth <= breakPoint ) {
		    	promise_swiper01 = new Swiper('.promise_swiper01', blog_options);
		  	} else {
		    	promise_swiper01 = undefined;
		  	}
		  	// $(window).on('resize', function(){
		 	window.addEventListener('resize', () => {
			    if ( window.innerWidth <= breakPoint ) {
			      	if( promise_swiper01 ) return;
			      	promise_swiper01 = new Swiper('.promise_swiper01', blog_options);
			    } else {
			      	if( !promise_swiper01 ) return;
			      	promise_swiper01.destroy();
			      	promise_swiper01 = undefined;
			    }
		  	}, false);
		}, false);
		//約束 スライド02
		$(function(){
			const breakPoint = 768;
		  	// blog_swiperのoption は使い回すので別に書く
		  	const blog_options = {
				slidesPerView: 'auto',
				spaceBetween:15,
				pagination: {
					el: ".swiper-pagination",
					clickable: true, // クリック可能にする
				},
				// 前後の矢印
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
		  	}
		  	let promise_swiper02;
		  	if ( window.innerWidth <= breakPoint ) {
		    	promise_swiper02 = new Swiper('.promise_swiper02', blog_options);
		  	} else {
		    	promise_swiper02 = undefined;
		  	}
		  	// $(window).on('resize', function(){
		 	window.addEventListener('resize', () => {
			    if ( window.innerWidth <= breakPoint ) {
			      	if( promise_swiper02 ) return;
			      	promise_swiper02 = new Swiper('.promise_swiper02', blog_options);
			    } else {
			      	if( !promise_swiper02 ) return;
			      	promise_swiper02.destroy();
			      	promise_swiper02 = undefined;
			    }
		  	}, false);
		}, false);
		//約束 スライド03
		$(function(){
			const breakPoint = 768;
		  	// blog_swiperのoption は使い回すので別に書く
		  	const blog_options = {
				slidesPerView: 'auto',
				spaceBetween:15,
				pagination: {
					el: ".swiper-pagination",
					clickable: true, // クリック可能にする
				},
				// 前後の矢印
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
		  	}
		  	let promise_swiper03;
		  	if ( window.innerWidth <= breakPoint ) {
		    	promise_swiper03 = new Swiper('.promise_swiper03', blog_options);
		  	} else {
		    	promise_swiper03 = undefined;
		  	}
		  	// $(window).on('resize', function(){
		 	window.addEventListener('resize', () => {
			    if ( window.innerWidth <= breakPoint ) {
			      	if( promise_swiper03 ) return;
			      	promise_swiper03 = new Swiper('.promise_swiper03', blog_options);
			    } else {
			      	if( !promise_swiper03 ) return;
			      	promise_swiper03.destroy();
			      	promise_swiper03 = undefined;
			    }
		  	}, false);
		}, false);
	}

	//スマホ・PCのみ
	$(window).on('load resize', function(){
	// $(window).on('load', function(){
		var w = $(window).width();
		if (w <= 768) {
			//スマホ時
		} else {
			//PC時
			//パララックス 上移動
			const elem_pc01 = document.querySelector(".parallax_up_pc");
			if (elem_pc01 !== null) {
				let target = document.getElementsByClassName("parallax_up_pc");
					let parallaxConfig = {
						delay: 0, // スクロール止めてから動く秒数
						orientation: "up", // 動く方向
						scale: 1.3, // 動く大きさ
						overflow: true,
					};
				const parallax_instance_pc01 = new simpleParallax(target, parallaxConfig);
			}
			//パララックス 下移動
			const elem_pc02 = document.querySelector(".parallax_down_pc");
			if (elem_pc02 !== null) {
				let target = document.getElementsByClassName("parallax_down_pc");
					let parallaxConfig = {
						delay: 0, // スクロール止めてから動く秒数
						orientation: "down", // 動く方向
						scale: 1.3, // 動く大きさ
						overflow: true,
					};
				const parallax_instance_pc02 = new simpleParallax(target, parallaxConfig);
			}
		}
	});
});